import format from "date-fns/format";
import { utcToZonedTime } from "date-fns-tz";
import React, { useState, useEffect } from "react";
import { Exercise } from "../../../models/Exercise";
import useMethodAccount from "../hooks/useMethodAccount";
import "./style.scss";

import { HiOutlineClock } from "react-icons/hi";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import ResignButton from "../../shared/Buttons/ResignButton";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  exercise: Exercise;
  getSelect: () => void;
}

const SingleExerciseDesktop: React.FC<IProps> = ({ exercise, getSelect }: IProps) => {
  const [open, setOpen] = useState(true);
  const { resignExercise } = useMethodAccount();
  const currentTime = new Date();
  const currentTimev2 = currentTime.getTime();
  const locale = useLocaleByLanguage();
  const isDesktop = useDesktopSize();
  const [cancelReservation, setCancelReservation] = useState<boolean>(true);
  const [now, setNow] = useState(Date.now());
  const exerciseStartTime = Number(exercise.startTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {exercise.startTime > currentTimev2 && (
        <div className="purchased-assort">
          <div className="purchased-assort_left">
            <div className="purchased-assort_startIcon">
              <b>{format(exercise.startTime, "MMM", { locale: locale })}</b>
              <b>{format(exercise.startTime, "d", { locale: locale })}</b>
            </div>

            <div className="purchased-assort_body">
              {exercise.status === "A" && <EAAlert type="success" compact message={"Zapisany"} />}
              {exercise.status === "R" && (
                <EAAlert
                  type="warning"
                  compact
                  message={`Lista rezerwowa, jesteś ${exercise.waitListPosition} w kolejce`}
                />
              )}
              <b className="purchased-assort_body__details">
                <HiOutlineClock /> Termin: {format(exercise.startTime, "dd.MM.yyyy")} |{" "}
                {format(utcToZonedTime(exercise.startTime, "Europe/Warsaw"), "HH:mm")}
                r.
              </b>

              <h5> {exercise.name}</h5>
            </div>
          </div>

          <div className="purchased-assort_action">
            <ResignButton
              cancelReservation={cancelReservation}
              setCancelReservation={setCancelReservation}
              onResign={async () => {
                await resignExercise(exercise, getSelect);
                setOpen(!open);
              }}
              exerciseStartTime={exerciseStartTime}
              now={now}
              isDesktop={isDesktop}
              ticket={exercise}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SingleExerciseDesktop;
